import { render, staticRenderFns } from "./OrdersListContainer.vue?vue&type=template&id=3d4024a0&scoped=true&"
import script from "./OrdersListContainer.vue?vue&type=script&lang=js&"
export * from "./OrdersListContainer.vue?vue&type=script&lang=js&"
import style0 from "./OrdersListContainer.vue?vue&type=style&index=0&id=3d4024a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4024a0",
  null
  
)

component.options.__file = "OrdersListContainer.vue"
export default component.exports